<template>
  <div :id="time">
    <v-container>
      <v-row class="center" style="position: relative; top: 50vh; left: 30vw">
        <v-col>
          <v-alert
            v-if="responseStatus.alertStatus"
            :type="responseStatus.type"
            width="320px"
            style="z-index: 9999"
            dense
            dismissible
            class="text-center"
          >
            {{ responseStatus.text }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>{{ name }}</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="12" v-for="item in lineLinkUrl" :key="item.name">
              <v-text-field
                v-model="linelink[item.name]"
                :label="item.label"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert(item.name)"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.register_page"
                label="หน้าลงทะเบียน"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('register_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.profile_page"
                label="หน้าโปรไฟล์"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('profile_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.product_page"
                label="หน้าสั่งสินค้า"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('product_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.redeem_page"
                label="หน้าแลกของรางวัล"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('redeem_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.redeem_history_page"
                label="หน้าประวัติการแลกของรางวัล"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('redeem_history_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field
                v-model="linelink.point_page"
                label="หน้าตรวจสอบคะแนน"
                readonly="readonly"
              >
                <v-icon
                  slot="append"
                  large
                  color="green darken-2"
                  @click="alert('point_page')"
                >
                  mdi-content-copy
                </v-icon>
              </v-text-field>
            </v-col> -->
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center"> </v-card-actions>
    </v-card>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import axios from "axios";

export default {
  data() {
    return {
      name: "ลิงค์ไลน์",
      time: new Date().toTimeString(),
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      payload: "",
      watchCode: "",
      domain: "https://" + JSON.parse(sessionStorage.getItem("profile"))["domain"],
      lineLiffId: JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"],
      contents: {},
      detail: "",
      lineLinkUrl: [
        { name: "register_page", label: "หน้าลงทะเบียน" },
        { name: "redeem_page", label: "หน้าแลกของรางวัล" },
        //{ name: "product_page", label: "หน้าสินค้า" },
        { name: "point_page", label: "หน้าคะแนน" },
        { name: "profile_page", label: "หน้าโปรไฟล์" },
        { name: "redeem_history_page", label: "หน้าประวัติการแลกของรางวัล" },
        { name: "privilege_page", label: "หน้าสิทธิพิเศษ" },
      ],
      linelink: {
        register_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/Register",
        redeem_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/Redeem",
        //product_page:
        //  "https://" +
        //  JSON.parse(sessionStorage.getItem("profile"))["domain"] +
        //  "/page/" +
        //  JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
        //  "/Product",
        point_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/RedeemPoint",
        profile_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/Profile",
        redeem_history_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/RedeemHistory",
        privilege_page:
          "https://" +
          JSON.parse(sessionStorage.getItem("profile"))["domain"] +
          "/page/" +
          JSON.parse(sessionStorage.getItem("profile"))["lineliff_id"] +
          "/Redeem02",
      },
      responseStatus: {
        alertStatus: false,
      },
    };
  },
  computed: {
    code() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      return this.$route.meta.code;
    },
    // detail() {
    //   //return this.$route.name;
    //   return this.contents.detail;
    // },
  },

  beforeMount() {
    console.log(JSON.parse(sessionStorage.getItem("profile")));
    console.log("beforeCreate");
    //this.getContents();

    console.log(this.$route);
    //this.detail = this.name;
  },
  methods: {
    alert(page) {
      //alert(this.linelink[page]);
      this.copyUrl(page);
    },
    copyUrl(page) {
      const el = document.createElement("textarea");
      el.value = this.linelink[page];
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        this.responseStatus = {
          status: "Success",
          code: 0,
          color: "green",
          type: "success",
          text: "Copied",
          alertStatus: true,
          //data: response.data.data,
        };
      } else {
        this.responseStatus = {
          status: "Failed",
          code: 0,
          color: "red",
          type: "error",
          text: "Copy failed",
          alertStatus: true,
          //data: response.data.data,
        };
      }
    },
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },
    //get content
    async getContents() {
      //let detail = "";
      //const url = process.env.VUE_APP_LOYALTY_API_URI;

      try {
        let payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
        };
        return await axios
          .get(
            this.api_uri + "/v1/contents/code/" + this.code,
            { params: payload } // need to change
          )
          .then((response) => {
            console.log(response);
            this.contents = response.data.data;
            this.detail = this.contents.detail;
            //this.watchCode = this.contents.code;
          });
      } catch (err) {
        console.log(err);
        this.contents = {};
      }
      //this.contents = detail;
    },
    reset() {
      //this.contents = this.contents;
    },
    async save() {
      //let uri = "/v1/contents/create";
      this.payload = {};
      if (this.contents._id === undefined) {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          code: this.code,
          detail: this.detail,
          name: this.name,
          status: "Active",
        };
        console.log(this.payload);
        await axios
          .post(
            this.api_uri + "/v1/contents/create",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response.data)
            //this.Product = response.data;
            this.contents = response.data.data;
            console.log(this.contents);
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
              data: response.data.data,
            };
            //console.log(this.responseStatus)
            //this.Product = response.data;
            //this.resetInput();
          });
      } else {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          id: this.contents._id,
          code: this.code,
          detail: this.detail,
          name: this.name,
          status: "Active",
        };
        console.log(this.payload);
        await axios
          .put(
            this.api_uri + "/v1/contents/update",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status == 0) {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data.data,
              };
            }
            //console.log(this.responseStatus)
            //this.Product = response.data;
            //this.resetInput();
          });
      }
    },
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
